<h1 class="mt-1 mb-0 heading-md text-bold">{{ 'header.manageMyTools.headline' | i18next }}</h1>
<p class="mb-1">{{ 'header.manageMyTools.copy' | i18next : { context: isLoggedIn ? 'isLoggedIn' : null } }}</p>
<div class="mb-2 d-flex flex-column">
  <a
    *ngFor="let link of links"
    [href]="link.url"
    shrdUicButton
    variant="tertiaryMinorBorderless"
    class="my-0 position-relative"
    
    (click)="storeVirtualPageDataAndTrackEvent(link.trackingData)"
  >
    <shrd-uic-svg-icon icon="arrow-right" size="small" />
    <span>{{ 'header.manageMyTools.' + link.label | i18next }}</span>
  </a>
</div>
<div *ngIf="!isLoggedIn" class="border-top border-neutral-light mx-n3 px-3">
  <shrd-ft-login-button
    [text]="'header.account.login' | i18next"
    variant="primary"
    additionalClasses="w-100 mb-1"
    [trackEvent]="loginClickTrackEvent"
  ></shrd-ft-login-button>
</div>
